import { createContext } from "react";
import type { FlexGroupPagedQuery } from "../dtos";
import type { IPaginationContext } from "../interfaces/Pagination/Pagination";

export const flexGroupListContext = createContext<IPaginationContext<FlexGroupPagedQuery>>({} as IPaginationContext<FlexGroupPagedQuery>)